import { Dispatch } from 'redux';
import types from 'redux/actions/actionTypes';
import { Society } from 'types';

type SocietyData = {
  societyShares?: {
    actual: number;
    future: number;
    total?: number;
    drafts: number;
  };
  societyPartnersCount?: {
    active: number;
    total: number;
    usufructuaries: number;
  };
  societyOperationsCount?: {
    total: number;
    constitution: number;
    capitalIncrease: number;
    capitalDecrease: number;
    sellParticipation: number;
    heritage: number;
    donation: number;
    endorsement: number;
    split: number;
    renumeration: number;
    reclassification: number;
    dividendsDistribution: number;
    contribution: number;
  };
  holdingClassesCount?: { total: number };
  societyData?: Partial<Society>;
};

const dispatchSocietyData = (
  type: string,
  data: Partial<SocietyData> | undefined,
  dispatch: Dispatch
) => {
  if (!data) return;

  const hasValidValue = Object.values(data).some(
    (value) => value !== undefined
  );

  if (hasValidValue) {
    dispatch({
      type,
      ...data,
    });
  }
};

export const updateSocietyData = (
  decodedData: SocietyData | null,
  dispatch: Dispatch
) => {
  const {
    societyShares,
    societyPartnersCount,
    holdingClassesCount,
    societyOperationsCount,
    societyData,
  } = decodedData || {};

  dispatchSocietyData(types.UPDATE_SOCIETY_SHARES, { societyShares }, dispatch);
  dispatchSocietyData(
    types.UPDATE_SOCIETY_PARTNERS_COUNT,
    { societyPartnersCount },
    dispatch
  );
  dispatchSocietyData(
    types.UPDATE_HOLDING_CLASSES_COUNT,
    { holdingClassesCount },
    dispatch
  );
  dispatchSocietyData(
    types.UPDATE_OPERATIONS_COUNT,
    { societyOperationsCount },
    dispatch
  );
  dispatchSocietyData(types.UPDATE_SOCIETY_DATA, { societyData }, dispatch);
};
